import { supabase } from '../supabaseClient';

// Version the tour when its core workflow changes so existing administrators
// receive the new Command overview once without losing prior metadata.
const TOUR_METADATA_KEY = 'admin_tour_v2_completed_at';

const storageKey = (userId: string) => `odinseye.adminTourV2Seen.${userId}`;

export const tourService = {
  /**
   * The tour should show on the user's first visit to the dashboard.
   * Completion is stored in Supabase auth user metadata so it follows the
   * user across devices, with localStorage as a fallback for sessions where
   * the metadata update failed.
   */
  async shouldShowTour(): Promise<boolean> {
    const { data, error } = await supabase.auth.getUser();
    const user = data.user;
    if (error || !user) return false;

    if (user.user_metadata?.[TOUR_METADATA_KEY]) return false;

    try {
      if (localStorage.getItem(storageKey(user.id))) return false;
    } catch {
      // localStorage unavailable (private browsing etc.) — metadata check above still applies
    }

    return true;
  },

  async markTourSeen(): Promise<void> {
    const { data } = await supabase.auth.getUser();
    const user = data.user;
    if (!user) return;

    const seenAt = new Date().toISOString();

    try {
      localStorage.setItem(storageKey(user.id), seenAt);
    } catch {
      // non-fatal
    }

    try {
      await supabase.auth.updateUser({ data: { [TOUR_METADATA_KEY]: seenAt } });
    } catch (err) {
      console.error('Failed to persist tour completion to user metadata', err);
    }
  },
};
